import { toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["aria-pressed"]
const _hoisted_2 = {
  class: "ml-auto h-4 w-4",
  focusable: "false",
  "aria-hidden": "true",
  width: "16",
  height: "16"
}
const _hoisted_3 = {
  key: 0,
  class: "pb-15 pt-10px text-xl"
}
const _hoisted_4 = {
  class: "sr-only",
  id: "date"
}
const _hoisted_5 = {
  class: "sr-only",
  id: "from"
}
const _hoisted_6 = {
  class: "sr-only",
  id: "to"
}
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  width: "16",
  height: "16",
  style: {"transform":"rotate(180deg)"},
  focusable: "false",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("button", {
      class: "search-toggle",
      "aria-pressed": _ctx.dateFilterVisible ? 'true' : 'false',
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDateFilter && _ctx.toggleDateFilter(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.t('dating')) + " ", 1),
      (_openBlock(), _createElementBlock("svg", _hoisted_2, [
        _createElementVNode("use", _normalizeProps(_guardReactiveProps({ 'xlink:href': '#arrow-down' })), null, 16)
      ]))
    ], 8, _hoisted_1),
    (_ctx.dateFilterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.t('date')), 1),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t('from')), 1),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.t('to')), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            pattern: "-?[0-9]*",
            inputmode: "numeric",
            class: "w-5ch",
            placeholder: _ctx.availableFilters.datings?.from,
            "aria-labelledby": "date from",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.validate('from'))),
            onKeydown: _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.handleEnter('from')), ["enter"])),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.from) = $event))
          }, null, 40, _hoisted_7), [
            [
              _vModelText,
              _ctx.from,
              void 0,
              { number: true }
            ]
          ]),
          _cache[9] || (_cache[9] = _createTextVNode("–", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            pattern: "-?[0-9]*",
            inputmode: "numeric",
            class: "ml-1ch w-5ch",
            placeholder: _ctx.availableFilters.datings?.to,
            "aria-labelledby": "date to",
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validate('to'))),
            onKeydown: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.handleEnter('from')), ["enter"])),
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.to) = $event))
          }, null, 40, _hoisted_8), [
            [
              _vModelText,
              _ctx.to,
              void 0,
              { number: true }
            ]
          ]),
          (_ctx.hasInput)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "-m-2 p-2",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.setDatingFilter && _ctx.setDatingFilter(...args)))
              }, [
                (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[8] || (_cache[8] = [
                  _createElementVNode("use", { "xlink:href": "#arrow-left" }, null, -1)
                ]))]))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}